import * as yup from 'yup';

import { i18n as I18n } from '../utils/i18n';
import { createGetValidator } from '../utils/validation';

const schema = yup.object({
  email: yup
    .string()
    .label(I18n.t('sign_in.email.label'))
    .email(
      I18n.t('sign_in.validations.email', {
        name: I18n.t('sign_in.email.label'),
      })
    )
    .required(
      I18n.t('sign_in.validations.required', {
        name: I18n.t('sign_in.email.label'),
      })
    ),
  password: yup
    .string()
    .label(I18n.t('sign_in.password.label'))
    .required(
      I18n.t('sign_in.validations.required', {
        name: I18n.t('sign_in.password.label'),
      })
    ),
});

export default schema;

export const getValidator = createGetValidator(schema);
